import { IPageEntity, IStoryEntity } from '@/graphql/__generated__/global/types';
import { createLanguageAlternates } from '@/helpers/createLanguageAlternates';
import { getBaseUrl } from '@/helpers/getBaseUrl';
import { findFullSlug } from '@/lib/strapiQueries';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

interface SeoProps {
    page: IPageEntity | IStoryEntity;
}

const Seo = ({ page }: SeoProps) => {
    const seo = page?.attributes?.seo;
    const localizations = page?.attributes?.localizations;
    const fullSlug = findFullSlug(page).join('/');
    const { locale } = useRouter();
    const canonicalURL = seo?.canonicalURL || `${getBaseUrl()}/${locale}/${fullSlug}`;
    const cmsNoIndex = seo?.metaRobots?.includes('noindex') || false;
    const cmsNoFollow = seo?.metaRobots?.includes('nofollow') || false;
    const noIndex = cmsNoIndex || process.env.NEXT_PUBLIC_ENV !== 'production';
    const noFollow = cmsNoFollow || process.env.NEXT_PUBLIC_ENV !== 'production';

    return (
        <NextSeo
            noindex={noIndex}
            nofollow={noFollow}
            title={seo?.metaTitle || 'Star RV'}
            description={seo?.metaDescription ?? ''}
            canonical={canonicalURL}
            languageAlternates={createLanguageAlternates(canonicalURL, localizations)}
            openGraph={{
                type: 'website',
                title: seo?.metaTitle || 'Star RV',
                description: seo?.metaDescription ?? '',
                siteName: 'Star RV',
            }}
        />
    );
};

export default Seo;
